/* eslint-disable */
import React from "react";
import RenderAdminPage from "../RenderAdminPage";
import FundContributionAnalysisPanel from "../../Components/FundContributionAnalysisPanel";

function FundContributionAnalysis() {
  return (
    <RenderAdminPage title="Contribution Analysis">
      <FundContributionAnalysisPanel accent="indigo" />
    </RenderAdminPage>
  );
}

export default FundContributionAnalysis;
